export enum TableColumnSizeType {
  xxsmall = 'xxsmall',
  xsmall = 'xsmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
  xlarge = 'xlarge',
  xxlarge = 'xxlarge',
}
